import { create } from 'zustand'

export interface UpgradePromptState {
  open: boolean
  reason: 'quota' | 'feature'
  title: string
  detail: string
  key: string | null
  limit: number | null
  show: (prompt: { reason: 'quota' | 'feature'; title?: string; detail: string; key?: string | null; limit?: number | null }) => void
  close: () => void
}

/** Global "upgrade your plan" prompt, opened on `quota-exceeded` / `feature-unavailable` problems. */
export const useUpgradePrompt = create<UpgradePromptState>()((set) => ({
  open: false,
  reason: 'quota',
  title: '',
  detail: '',
  key: null,
  limit: null,
  show: ({ reason, title, detail, key = null, limit = null }) =>
    set({
      open: true,
      reason,
      title: title ?? (reason === 'quota' ? 'You’ve reached your plan limit' : 'Upgrade to unlock this feature'),
      detail,
      key,
      limit,
    }),
  close: () => set({ open: false }),
}))
